import styled, { css } from "styled-components";

export const CardWrapper = styled.li`
  position: relative;
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  width: 85%;
  height: 22rem;
  padding: 1rem;
  margin: 0 auto 2rem;
  border-radius: 10px;
  box-shadow: 6px 6px 7px 0 rgb(190, 190, 190);
  max-width: 650px;

  // 리펙토링 시급
  ${(props) => {
    const theme = props.cardTheme;
    return css`
      background-color: ${theme === "light"
        ? " whitesmoke"
        : "rgb(68, 66, 66)"};
      color: ${theme === "dark" ? " whitesmoke" : "rgb(68, 66, 66)"};
    `;
  }}
`;

export const ProfileImg = styled.img`
  margin: auto 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15rem;
  height: 15rem;
  border-radius: 50%;
`;

export const CardInfoWrapper = styled.div`
  height: 15rem;
  width: 100%;
  padding: 0.8rem;
`;

export const Name = styled.h2`
  font-size: 2.8rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const Company = styled.p`
  color: rgb(150, 150, 150);
  margin-left: 0.3rem;
`;

export const Title = styled.p`
  font-size: 2.2rem;
  margin-bottom: 1rem;
`;

export const Email = styled.p`
  margin-bottom: 1rem;
`;

export const Message = styled.p`
  color: rgb(150, 150, 150);
`;

export const OpenButton = styled.button`
  position: absolute;
  top: 5px;
  left: 5px;

  align-self: flex-start;

  background-color: transparent;
  border: none;
  min-width: 8rem;
  font-size: 1.2rem;
  padding: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;

  &:hover {
    opacity: 0.8;
  }
  ${(props) => {
    const { color } = props;
    return css`
      color: ${color === "dark" ? "whitesmoke" : "black"};
      border: 1px solid ${color === "dark" ? "whitesmoke" : "black"};
    `;
  }}
`;

// CARD MODAL //

export const DarkBackGround = styled.div`
  position: fixed;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FixedCardWrapper = styled(CardWrapper)`
  /* FIXED */
  width: 400px;
  height: 220px;
  box-shadow: none;
  margin: 0;
`;
export const DownloadButton = styled.button`
  background-color: transparent;
  border: 2px solid black;
  border-radius: 5px;
  width: 100%;
  font-size: 1.6rem;
  height: 3rem;
  color: black;
  cursor: pointer;
  font-weight: bold;
  &:hover {
    opacity: 0.6;
  }
`;
export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  color: white;
  cursor: pointer;
  align-self: flex-end;
  justify-content: flex-end;
  align-items: flex-end;
  font-size: 2.4rem;
  font-weight: bold;
  &:hover {
    opacity: 0.6;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  /* background-color: aliceblue; */
`;
